module.exports = __webpack_public_path__ + "static/img/06.f75367f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-assetsM/06.jpg
// module id = hQUf
// module chunks = 1